import { render, staticRenderFns } from "./adminBlog.vue?vue&type=template&id=2d64e5be"
import script from "./adminBlog.vue?vue&type=script&lang=js"
export * from "./adminBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports